import { TTradeInVehicle } from 'src/interfaces/evaluation';

export const DEFAULT_TRADE_IN_VEHICLE: TTradeInVehicle = {
    make: { id: '', name: '' },
    model: '',
    year: 0,
    clientPrice: 0,
    storePrice: 0,
};
